import React from "react";
import { Button, Col, Row } from "reactstrap";

const WelcomeScreen = ({setHandleContinue, content, welcomeImage, youtubeLink}) => {
  const handleNextContinue = () => {
    setHandleContinue(true);
  };

  return (
    <Col lg="12">
      <div className="complaint-card shadow">
        <Row className="p-4">
          <Col className="col-sm-12 col-lg-7">
          
            {content()}
          </Col>
          <Col className="col-sm-12 col-lg-5">
            <div className="w-full mt-5 mb-3 d-flex justify-content-center">
              <img src={welcomeImage} height={200} />
            </div>

            <div className="d-flex justify-content-center align-items-center mt-5">
              <Button color="primary">
                <a
                  href={youtubeLink}
                  target="_blank"
                  className="text-white"
                >
                  Play Video
                </a>
              </Button>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <Button color="primary" onClick={handleNextContinue}>
                Continue
              </Button>
            </div>
          </Col>
        </Row>
      </div>
    </Col>
  );
};

export default WelcomeScreen;
